import { render } from "./CarouselCell.vue?vue&type=template&id=708be8f4&scoped=true&bindings={}"
import script from "./CarouselCell.vue?vue&type=script&lang=ts"
export * from "./CarouselCell.vue?vue&type=script&lang=ts"

import "./CarouselCell.vue?vue&type=style&index=0&id=708be8f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-708be8f4"

export default script